import script from "./MenuItemTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuItemTabs.vue?vue&type=script&setup=true&lang=js"

import "./MenuItemTabs.vue?vue&type=style&index=0&id=8a2f8210&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a2f8210"]])

export default __exports__